import { WINDOW } from '../../../types.js';

/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var whenActivated = function whenActivated(callback) {
  var _WINDOW$document;
  if ((_WINDOW$document = WINDOW.document) !== null && _WINDOW$document !== void 0 && _WINDOW$document.prerendering) {
    addEventListener('prerenderingchange', function () {
      return callback();
    }, true);
  } else {
    callback();
  }
};
export { whenActivated };